<div class="searchInputBar__cont">
  <app-ds-input-text
    [size]="inputSize"
    [isReadonly]="readonly"
    [filled]="filled"
    [staticFilled]="staticFilled"
    [icon]="icon"
    [isDisabled]="disabled"
    [label]="label"
    [placeholder]="placeholder"
    [value]="value"
    (clickEvent)="inputFocus.emit()">
  </app-ds-input-text>
</div>
